<div class="bg-slate-50">
  <ng-container [formGroup]="userRoleFormGroup">
    <label class="roler p-2" *ngIf="isAdminPage" for="roles">Roles</label>
    <p-fluid>
      <div class="input-Row align-items-center">
        <div
          class="m-0"
          [ngClass]="isProfilePage ? 'inputColumnFull' : 'inputColumn1of2'"
        >
          <div class="field m-0 p-1">
            <p-multiselect
              inputId="roles"
              class="inputValue"
              [ngClass]="isProfilePage ? 'multiselect-disabled' : ''"
              [disabled]="isReadOnly"
              appendTo="body"
              display="chip"
              [maxSelectedLabels]="isReadOnly ? 12 : 6"
              [placeholder]="isProfilePage ? '' : 'Select'"
              formControlName="role"
              [options]="roles"
              optionLabel="roleName"
              optionValue="roleId"
              [filter]="true"
              filterBy="roleName"
              aria-labelledby="roles"
              (onChange)="checkPermissions($event)"
              data-testid="shared-user-roles-multiselect"
            ></p-multiselect>
          </div>
        </div>
        <div
          class="flex flex-1 align-items-center ultiFactAuthContainer"
          *ngIf="isAdminPage"
        >
          <div class="status" [ngClass]="status.toLocaleLowerCase()">
            <span class="indicator"></span
            ><span class="label">{{ status }}</span>
          </div>
          <div class="flex align-items-center">
            <div class="field m-0 p-2 bg-surface-200 border-round-sm">
              <label class="flex align-items-center mr-1 ml-1 mt-1">
                <i
                  class="pi pi-check-circle mr-1"
                  [ngClass]="
                    isMfaEnable || tenantMfaEnabled
                      ? 'color-success pi-check-circle'
                      : 'color-danger pi-times-circle'
                  "
                ></i
                >Multi-Factor Auth</label
              >
            </div>
          </div>
          <div class="flex align-items-center">
            <div class="field ml-2 p-2 m-0 bg-surface-200 border-round-sm">
              <label class="flex align-items-center mr-1 ml-1 mt-1"
                >Last Logged On:
                <span class="text-sm ml-1">{{
                  lastLoggedInDateTime
                }}</span></label
              >
            </div>
          </div>
        </div>
      </div>
    </p-fluid>
    <div class="bg-slate-100 ml-2 mr-2 custom-height"></div>
    <div
      class="col-12 p-0 m-1 uerRolesPermissionsContainer"
      [ngClass]="isProfilePage ? 'px-2' : ''"
    >
      <div class="permissionsContainer" *ngFor="let pGroup of permissionGroups">
        <label class="w-full p-1 m-0 mt-1 text-sm">{{
          pGroup.groupName
        }}</label>
        <div
          class="w-full p-1 flex mb-1 align-items-center"
          *ngFor="let permission of pGroup.permissions"
        >
          <i
            class="pi mr-1"
            [ngClass]="
              permission.checked
                ? 'pi-check-circle color-success'
                : 'pi-times-circle color-surface-400'
            "
          ></i>
          <span
            class="text-xs"
            [ngClass]="permission.checked ? 'bold' : 'color-surface-400'"
            >{{ permission.permissionDisplayName }}</span
          >
        </div>
      </div>
    </div>
  </ng-container>
</div>
